import api from '@/api/kudos';

const create = (_, payload) => new Promise(((resolve, reject) => {
  api.create(payload)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));
const thank = (_, code) => new Promise(((resolve, reject) => {
  api.thank(code)
    .then((response) => {
      resolve(response);
    })
    .catch((error) => {
      // eslint-disable-next-line
      console.error(error);
      reject(error);
    });
}));


export default {
  create,
  thank,
};

